'use client';

import type { FC } from 'react';
import { Button } from './ui/Button';
import { BonusCredits } from './BonusCredits';
import { CreditsText } from './caseBattle/atoms';
import { RiLockLine } from './icons';
import { useLocalTranslation } from '../hooks/useLocalTranslation';
import type { CaseAffordability } from '../hooks/useCaseAffordability';
import translations from './CaseAffordabilityCta.translations';

interface CaseAffordabilityCtaProps {
  affordability: CaseAffordability;
  onJoinClick: () => void;
  onTopupClick: () => void;
}

export const CaseAffordabilityCta: FC<CaseAffordabilityCtaProps> = ({
  affordability,
  onJoinClick,
  onTopupClick,
}) => {
  const { t } = useLocalTranslation(translations);
  const { isLocked, isBonusCase, missingAmount } = affordability;

  if (isLocked) {
    return (
      <Button size="l" stretched variant="cta" before={<RiLockLine size={16} />} onClick={onJoinClick}>
        {t('bandJoinToOpen')}
      </Button>
    );
  }

  if (isBonusCase) {
    return (
      <div className="flex flex-col gap-1.5">
        <Button
          size="l"
          stretched
          variant="cta"
          disabled
          before={<BonusCredits amount={0} iconOnly iconSize={16} />}
        >
          {t('bandInsufficientBonusButton')}
        </Button>
        <p className="px-2 text-center text-[11px] leading-snug text-label-secondary">
          {t('bandInsufficientBonusHint')}
        </p>
      </div>
    );
  }

  return (
    <Button size="l" stretched variant="cta" onClick={onTopupClick}>
      <CreditsText template={t('topupShort')} placeholder="missing" amount={missingAmount} iconSize={14} />
    </Button>
  );
};
